import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { EbookMockup } from './EbookMockup';
export function FinalCTA() {
  return <section className="py-24 md:py-32 relative overflow-hidden border-t border-gold/20 bg-black" data-id="element-83">
      {/* Cinematic Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[600px] bg-gold-glow rounded-full blur-3xl opacity-40 pointer-events-none" data-id="element-84"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-85">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-86">
          {/* Stacked Books Visual */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative h-[500px] md:h-[600px] flex items-center justify-center order-2 lg:order-1" data-id="element-87">
            <div className="relative w-full max-w-sm mx-auto" data-id="element-88">
              <div className="absolute top-0 left-12 scale-90 opacity-40 blur-[2px] transform -translate-y-10" data-id="element-89">
                <EbookMockup tilt={-25} delay={0.4} image="https://cdn.magicpatterns.com/uploads/2KzzAymubxUoD4Tic3zFGm/500_PROMPS_COVER.png" data-id="element-90" />
              </div>
              <div className="absolute top-10 left-6 scale-95 opacity-80 transform -translate-y-5" data-id="element-91">
                <EbookMockup tilt={-20} delay={0.2} image="https://cdn.magicpatterns.com/uploads/2KzzAymubxUoD4Tic3zFGm/500_PROMPS_COVER.png" data-id="element-92" />
              </div>
              <div className="relative z-10" data-id="element-93">
                <EbookMockup tilt={-15} image="https://cdn.magicpatterns.com/uploads/2KzzAymubxUoD4Tic3zFGm/500_PROMPS_COVER.png" data-id="element-94" />
              </div>
            </div>
          </motion.div>

          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col items-start order-1 lg:order-2 text-center lg:text-left" data-id="element-95">
            <h2 className="font-display text-5xl md:text-6xl text-cream mb-6 leading-[1.1]" data-id="element-96">
              Empieza a trabajar más{' '}
              <span className="text-gold italic" data-id="element-97">inteligentemente</span> hoy.
            </h2>

            <p className="text-cream/60 text-lg md:text-xl font-light mb-10" data-id="element-98">
              Obtén acceso instantáneo a los 500 prompts y los 3 bonos premium.
              Diseñado para ahorrarte horas cada semana.
            </p>

            <div className="w-full sm:w-auto mx-auto lg:mx-0" data-id="element-99">
              <Button variant="primary" className="w-full sm:w-auto !px-12 !py-5 text-lg" href="https://shop.aiparaempresarios.com/products/la-biblia-de-500-prompts-para-profesionales" data-id="element-100">
                Obtener Acceso Inmediato
              </Button>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 sm:gap-8 text-xs text-cream/40 uppercase tracking-widest mx-auto lg:mx-0" data-id="element-101">
              <span className="flex items-center gap-2" data-id="element-102">
                <div className="w-1 h-1 bg-gold rounded-full" data-id="element-103"></div> Acceso
                inmediato
              </span>
              <span className="flex items-center gap-2" data-id="element-104">
                <div className="w-1 h-1 bg-gold rounded-full" data-id="element-105"></div> Descarga
                instantánea
              </span>
              <span className="flex items-center gap-2" data-id="element-106">
                <div className="w-1 h-1 bg-gold rounded-full" data-id="element-107"></div> Pago único
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}